import React from 'react';
import { Link, useLocation } from "react-router-dom";

function Breadcrumb({title,header}) {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);
    const from = location.state?.from || [];
    let fullBreadcrumb = [];
    
    // Tambahkan pathnames ke breadcrumb
    // pathnames.forEach((path, index) => {
    //     const fullPath = `/${pathnames.slice(0, index + 1).join("/")}`;
    //     const isDuplicate = fullBreadcrumb.some((crumb) => crumb.path === fullPath);

    //     if (!isDuplicate) {
    //         fullBreadcrumb.push({
    //             label: path.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()), // Format label
    //             path: fullPath,
    //         });
    //     }
    // });

    if (from.length > 0) {
        // Gunakan hanya `from` jika tersedia
        fullBreadcrumb = [...from];
    } else {
        // Gunakan `pathnames` jika `from` tidak tersedia
        fullBreadcrumb = pathnames.map((path, index) => ({
            label: path.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()), // Format label
            path: `/${pathnames.slice(0, index + 1).join("/")}`, // Bangun path lengkap
        }));
    }
    

    // if (from) {
    //     fullBreadcrumb = [from, ...pathnames];
    // } else {
    //     fullBreadcrumb = [...pathnames];
    // }

    const formatLabel = (slug) => {
        return slug
            .replace(/-/g, ' ')              
            .replace(/\b\w/g, l => l.toUpperCase()); 
    };

    return (
        <div className='app-toolbar pt-4 pt-lg-7 mb-n2 mb-lg-n3'>
            <div className='app-container container-xxl d-flex flex-stack flex-row-fluid'>
                <div className='d-flex flex-stack flex-row-fluid'>
                    <div className='d-flex flex-column flex-row-fluid'>
                        <ul className='breadcrumb breadcrumb-separatorless fw-semibold mb-1 mb-lg-3 me-2 fs-7'>
                            <li className="breadcrumb-item text-gray-700 fw-bold lh-1">
                                <Link to={'/dashboard'} className="text-white text-hover-primary">
                                    <i className="ki-outline ki-home text-gray-700 fs-6"></i>
                                </Link>
                            </li>
                   
                            {fullBreadcrumb.map((value, index) => {
                                // const to = `/${fullBreadcrumb.slice(0, index + 1).join("/")}`;
                                const to = value.path;
                                const isLast = index === fullBreadcrumb.length - 1;
                                const formatted = formatLabel(value.label);
                                

                                return (
                                    <React.Fragment key={to}>
                                        <li className="breadcrumb-item">
                                            <i className="ki-outline ki-right fs-7 text-gray-700 mx-n1"></i>
                                        </li>
                                        {isLast ? (
                                            <li className="breadcrumb-item text-gray-700 fw-bold lh-1" aria-current="page">
                                                {formatted}
                                            </li>
                                        ) : (
                                            <li className="breadcrumb-item text-gray-700 fw-bold lh-1">
                                                <Link to={to}>
                                                    {/* {value.charAt(0).toUpperCase() + value.slice(1)} */}
                                                    {formatted}
                                                </Link>
                                            </li>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </ul>
                        <div className="page-title d-flex align-items-center me-3">
                            <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">{header}</h1>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    );
}

export default Breadcrumb;
